import { useEffect, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";

export default function MobileJoinZoom({ ZoomUrl, iframeRef }) {
  const [SideOpener, setSideOpner] = useState(false);
  const OpenSideMenu = (e) => {
    e.preventDefault();
    setSideOpner(!SideOpener);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="LiveClass" />
        <div className="main-content">
          <MobileHeaderSection Page="Live Class" OpenSideMenu={OpenSideMenu} />
          <div
            style={{ padding: "20px" }}
            className="zoom-content"
            id="dashboardPage"
          >
            <div>
              {ZoomUrl ? (
                <iframe
                  ref={iframeRef}
                  src={ZoomUrl}
                  width="100%"
                  height={window.innerWidth <= 580 ? "530" : "600"}
                  frameborder="0"
                  id="zoom-frame"
                  allow="microphone; camera;display-capture; fullscreen "
                  allowfullscreen
                  webkitallowfullscreen
                  mozallowfullscreen
                  // onLoad={() => {
                  //   setTimeout(() => {
                  //     console.log("marked_arr");
                  //     // fetch("/api/mark-attendance", {
                  //     //   method: "POST",
                  //     //   body: JSON.stringify({ userId }),
                  //     //   headers: { "Content-Type": "application/json" },
                  //     // });
                  //   }, 10000); // 10-second confirmation
                  // }}
                  title="Zoom"
                ></iframe>
              ) : (
                ""
              )}{" "}
            </div>
          </div>
          <MobileBottomMenu Page="LiveClass" />
        </div>
      </div>
    </>
  );
}
